import React from 'react';

import MeshRecommendsPaper from 'components/MeshRecommendsPaper/MeshRecommendsPaper';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Divider1, VerticallyAlignedFlexContainer } from 'styles/common';

import { LogoWithoutNameImage } from 'constants/icons';
import { sendClickedOnMeshRecommendsEvent } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { Typography13 } from 'uiToolkit/Typography';

import useLevelUpSidePanelContext from '../../context';
import { showCompetencySidePanelService } from '../../services';

const MeshRecommends = ({ forceUpdate = () => {} }) => {
  const {
    state: { reporteeId, isLoading, levelUpCompetencyDetails },
  } = useLevelUpSidePanelContext();

  const { accessible } = levelUpCompetencyDetails ?? {};

  const history = useHistory();

  const { recommendations = [] } = levelUpCompetencyDetails;

  const meshRecommends = recommendations;

  const onRecommendsClick = ({ competencyId, levelUpId, scrollToId }) => {
    if (competencyId && levelUpId) {
      showCompetencySidePanelService({
        history,
        employeeId: reporteeId,
        competencyId,
        levelUpId,
        scrollToId,
      });
      sendClickedOnMeshRecommendsEvent({
        eventProperties: {
          source: 'LevelUp module',
          type: 'LevelUp',
        },
      });
      forceUpdate();
    }
  };

  if (!accessible || !meshRecommends?.length) {
    return null;
  }

  return (
    <MeshRecommendsPaper>
      <Container>
        <VerticallyAlignedFlexContainer style={{ marginBottom: '1rem' }}>
          <img src={LogoWithoutNameImage} alt="Logo" style={{ width: '18px', height: '18px', marginRight: '0.5rem' }} />
          <Typography13 weight={600}>Mesh Recommends</Typography13>
        </VerticallyAlignedFlexContainer>
        <Divider1 />
        {meshRecommends?.map((recommendation, index) => {
          const {
            competencyId,
            landingPageType,
            levelUpId,
            reason,
            recommendation: recommendationHyperLink,
          } = recommendation;
          return (
            <div style={{ paddingTop: '0.5rem' }}>
              {/* <Typography13>{recommendation?.competencyName}</Typography13> */}
              <Typography13>
                <HyperLinkSpan
                  onClick={() =>
                    onRecommendsClick({
                      competencyId,
                      levelUpId,
                      scrollToId: landingPageType,
                    })
                  }
                >
                  {recommendationHyperLink}
                </HyperLinkSpan>
                <span> {reason}</span>
              </Typography13>
            </div>
          );
        })}
      </Container>
    </MeshRecommendsPaper>
  );
};

const Container = styled.div`
  padding: 1rem;
`;

const OrderedList = styled.ol`
  padding-left: 1.25rem;
  font-family: 'Source Sans Pro';
`;

const ListElement = styled.li``;

const HyperLinkSpan = styled.span`
  color: ${theme.palette.primary.main};
  cursor: pointer;
`;

export default MeshRecommends;
